import { render, staticRenderFns } from "./TopShop.vue?vue&type=template&id=9d48c088&scoped=true"
import script from "./TopShop.vue?vue&type=script&lang=js"
export * from "./TopShop.vue?vue&type=script&lang=js"
import style0 from "./TopShop.vue?vue&type=style&index=0&id=9d48c088&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d48c088",
  null
  
)

export default component.exports